export default {"src":"/_next/static/media/oot.b18adb7f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};